import PendingRequestsList from "@/features/users/ui/pending-requests-list";

export default function PendingRequests() {
  return <PendingRequestsList />;
}
